import React, { useState, useEffect } from "react";
import {useApplicationContext} from '../../../provider'
import {getContent} from '../../../react-hooks/useContentCompiler'
import BTConstant from "../../../utils/bt-constant";

export default function Footer ({ context }) {

  const { handleBarCompiler } = useApplicationContext()
  const [footerContent, setFooterContent] = useState('')
  const rawTemplate = require(`raw-loader!../../../compiled/braintree/templates/partials/footer/global_footer.hbs`)  
  const alignCenter = [BTConstant.ARTICLES_PREFIX, BTConstant.DOC_PREFIX].includes(context.currentPath) ? true : false  
  useEffect(()=>{
    setFooterContent(getContent(rawTemplate, handleBarCompiler, {...context, "align-center": alignCenter, "paypalReturnUrl":false}))
  },[context])
  return (
    <>
      <div dangerouslySetInnerHTML={{__html: footerContent}} />
    </>
  );
};
